import React from 'react'
import { DashboardCardsProps } from './DashboardCards.types'
import styles from './DashboardCards.module.scss'
import cl from 'classnames'
import { DashboardCard } from './DashboardCard/DashboardCard'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { DASHBOARD_PAGE_STORE, ROUTING_STORE } from 'store'
import { dashboardCardPropsRepo } from './DashboardCards.utils'

const DashboardCardsComponent = (props: DashboardCardsProps) => {
  const {
    className,
    style,
    [DASHBOARD_PAGE_STORE]: {
      orderedCardLabels
    },
    [ROUTING_STORE]: {
      push
    }
  } = props

  if (!orderedCardLabels.length) return null

  const handleRelocation = (label) => {
    console.log(label)
    switch (label) {
      case 'Projects': {
        push('/projects')
        break
      }
      case 'Agreements': {
        push('/agreements')
        break
      }
      case 'People': {
        push('/persons')
        break
      }
      case 'Products': {
        push('/products')
        break
      }
      case 'Stores': {
        push('/brands')
        break
      }
      case 'Users': {
        push('/user-management')
        break
      }
      default:
        break
    }
  }
  return (
    <div
      key={orderedCardLabels.length}
      className={cl(styles.container, className)}
      style={style}
    >
      {orderedCardLabels.map((label, index) => {
        return (
          <div key={index} style={{ cursor: 'pointer', width: '100%' }} onClick={() => handleRelocation(label)} >
            <DashboardCard
              {...dashboardCardPropsRepo[label]}
            />
          </div>
        )
      })}
    </div >
  )
}

const DashboardCards = inject(
  DASHBOARD_PAGE_STORE,
  ROUTING_STORE
)(observer(DashboardCardsComponent))
export { DashboardCards }
